import React from 'react';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import Image from '@gcloud-npm/next12.components.image-n';
import useMediaQuery from '@/hooks/useMediaQuery';
// import BackBar from '@/components/BackBar';

const HeaderValley = (props) => {
  const { tipoEmpresa, link } = props;

  const taggingInfo = {
    componentProduct: '',
    componentVariation: tipoEmpresa || 'all',
    componentName: 'HeaderValley',
  };

  const isMobile = useMediaQuery('(max-width: 768px)');
  const alturaHeader = isMobile ? 70 : 92;
  return (
    <>
      <section className="HeaderValley fixed" id="HeaderValley">
        <div className="container">
          <div className="HeaderValleyBar">
            <CustomLink
              taggingInfo={{
                ...taggingInfo,
                componentContent: 'HeaderValleyBar',
              }}
              href={link}
            >
              {isMobile ? (
                <Image
                  src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].picMobile.src}`}
                  alt={props['Image-1'].alt}
                  layout="fixed"
                  width={props['Image-1'].picMobile.width}
                  height={props['Image-1'].picMobile.height}
                />
              ) : (
                <Image
                  src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].picDesktop.src}`}
                  alt={props['Image-1'].alt}
                  layout="fixed"
                  width={props['Image-1'].picDesktop.width}
                  height={props['Image-1'].picDesktop.height}
                />
              )}
            </CustomLink>
            <div className="title">
              <TextInfo {...props['TextInfo-1']} />
            </div>
          </div>
        </div>
      </section>
      <div className="wrapper-backBar" style={{ marginTop: alturaHeader }}>
        {/* <BackBar /> */}
      </div>
      <style jsx>
        {`
          .HeaderValley {
            background-color: var(--color-emp--grey1);
            width: 100%;
            z-index: 10;
            .HeaderValleyBar {
              display: flex;
              align-items: center;
              height: 4.5rem;
              padding: 0 1rem 0 0.6875rem;
              .title {
                margin-left: auto;
              }
            }
          }
          .fixed {
            position: fixed;
            z-index: 10;
            top: 0;
          }

          @media screen and (min-width: 769px) {
            .HeaderValley {
              .HeaderValleyBar {
                height: 5.625rem;
                .floatingAlignRight {
                  margin-left: auto;
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default HeaderValley;
